import { render } from "./BaseHero.vue?vue&type=template&id=0409063d"
import script from "./BaseHero.vue?vue&type=script&lang=js"
export * from "./BaseHero.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__